// This module provides helper functions for adding tracking attributes to elements.
// Render an element and pass `trackClick()` as a spread prop, such as:
// <button {...trackClick('button-clicked', { id: '123' })}>Click me</button>
//
// As long as the event is propagated up the DOM tree, the event will be tracked, along with
// any elements up the DOM tree that have tracking attributes.
//
// You can also manually add the properties to an element, such as:
// <button data-analytics-event="button-clicked" data-analytics-value='{"id": "123"}'>Click me</button>
//
// Note that event data must be JSON stringified, if provided.
//
// Note that due to some functionality in Chakra this does NOT work when the event is triggered inside
// a modal or element that utilizes modal functionality, such as the <AlertDialog>. This is because
// the modal intercepts all events and stops them from propagating up the DOM tree, I'm assuming to
// trap focus within the dialog.

type InlineEventAttrs = {
	'data-analytics-event': string;
	'data-analytics-value'?: string;
};

export const trackClick = (eventName: string, properties?: Record<string, any>) => {
	const attrs: InlineEventAttrs = {
		'data-analytics-event': eventName,
	};

	if (properties) {
		attrs['data-analytics-value'] = JSON.stringify(properties);
	}

	return attrs;
};

export const parseEventData = (dataset: DOMStringMap) => {
	const event = dataset.analyticsEvent;
	const value = dataset.analyticsValue;

	try {
		return { event, value: value ? JSON.parse(value) : undefined };
	} catch (error) {
		console.error(`Unable to parse event data attribute for ${event}`);
		return {};
	}
};
